import * as types from "../actions/constants";

const INITIAL_STATE = {
  userInfo: {},
  isLoading: false,
  loginError: "",
  createAccountError: "",
  changePassError: "",
  changePassSuccess: false,
  changePassSuccessMsg: "",
  updateAccountSuccess: false,
  updateAccountSuccessMsg: "",
  updateAccountError: "",
  updateLoading: false,
  resetPasswordError: false,
  resetPasswordSuccess: false
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      return { ...state, loginError: "", userInfo: action.payload };
    case types.LOGIN_ERROR:
      return { ...state, loginError: action.payload };
    case types.LOGOUT_SUCCESS:
      return { ...state, userInfo: {} };
    case types.CREATE_ACCOUNT_SUCCESS:
      return { ...state, createAccountError: "", userInfo: action.payload };
    case types.CREATE_ACCOUNT_ERROR:
      return { ...state, createAccountError: action.payload };
    case types.CHANGE_PASS_SUCCESS:
      return {
        ...state,
        changePassSuccess: true,
        changePassSuccessMsg: action.payload,
        changePassError: ""
      };
    case types.CHANGE_PASS_ERROR:
      return {
        ...state,
        changePassError: action.payload,
        changePassSuccess: false,
        changePassSuccessMsg: ""
      };
    case types.UPDATE_ACCOUNT_SUCCESS:
      return {
        ...state,
        updateAccountSuccess: true,
        updateAccountSuccessMsg: action.message,
        updateAccountError: "",
        userInfo: { ...state.userInfo, ...action.data }
      };
    case types.CLEAN_UPDATE_MSG:
      return {
        ...state,
        updateAccountSuccess: false,
        updateAccountSuccessMsg: "",
        updateAccountError: ""
      };
    case types.SET_UPDATE_ERROR:
      return {
        ...state,
        updateAccountSuccess: false,
        updateAccountError: action.payload
      };
    case types.SET_UPDATE_LOADING:
      return { ...state, updateLoading: action.payload };
    case types.LOADING:
      return { ...state, isLoading: action.isLoading };
    case types.GET_USER:
      return { ...state, userInfo: action.payload };
    case types.RECOVER_PASSWORD_SUCCESS:
      return { ...state, resetPasswordSuccess: true };
    case types.RECOVER_PASSWORD_FAILED:
      return { ...state, resetPasswordError: true };
    case types.CLEAN_RECOVER_STATE:
      return { ...state, resetPasswordError: false };
    default:
      return state;
  }
};
